import { ILoggerService } from '@nodeModules/@itero/itero-platform-login';
import { IShellContext } from '@shared/store/IShellContext';
import { SessionInfo } from '../../authentication/auth.service';

export class IteroPlatformLoginInput {
	clientDiscoveryEndpoint: string;
	loggerService: ILoggerService;
	smsEndpoint: string;
	loginBffEndpoint: string;
}

export class LoginResponse {
	context: IShellContext;
	sessionInfo: SessionInfo;
	returnUri: string;
}
